import api from "@/axios";
import type {
    ProductionByMachineReportResponse,
    ProductionByMachineReportParams,
    SalesByCustomerReportResponse,
    SalesByCustomerReportParams,
    ReportQualityProduction,
    ProductionByQualityReportParams,
    ProductionBySupplierReportParams,
    ProductionByQualityReportResponse,
    ProductionBySupplierReportResponse,
    SalesByQualityReportParams,
    SalesByQualityReportResponse,
    CostToSaleAnalysisReportParams,
    CostToSaleAnalysisReportResponse,
    YarnStockValueParams,
    YarnStockValueResponse, BatchStockResponse, BatchStockParams
} from '@/types/report-types';

export const getProductionByMachine = async (params: ProductionByMachineReportParams): Promise<ProductionByMachineReportResponse> => {

    const response = await api.get<ProductionByMachineReportResponse>('/reports/production-by-machine', {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            machineNumber: params.machineNumber
        }
    });
    return response.data;
};

export const getProductionByQuality = async (params: ProductionByQualityReportParams): Promise<ProductionByQualityReportResponse> => {
    const response = await api.get('/reports/production-by-quality', {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            qualityId: params.qualityId
        }
    });
    return response.data;
}

export const getProductionBySupplier = async (params: ProductionBySupplierReportParams): Promise<ProductionBySupplierReportResponse> => {
    const response = await api.get<ProductionBySupplierReportResponse>('/reports/production-by-supplier', {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            supplierId: params.supplierId,
            ...(params.serviceTypes !== undefined && { ServiceTypes: params.serviceTypes })
        }
    });
    return response.data;
}

export const getSalesByCustomer = async (
  params: SalesByCustomerReportParams
): Promise<SalesByCustomerReportResponse> => {
    const response = await api.get<SalesByCustomerReportResponse>('/reports/sales-by-customer', {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            customerId: params.customerId,
        }
    });
    return response.data;
};

export const getSalesByQuality = async (
    params: SalesByQualityReportParams
): Promise<SalesByQualityReportResponse> => {
    const response = await api.get<SalesByQualityReportResponse>('/reports/sales-by-quality', {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            qualityId: params.qualityId,
            currency: params.currency,
        }
    });
    return response.data;
};

export const getCostToSaleAnalysis = async (
    params: CostToSaleAnalysisReportParams
): Promise<CostToSaleAnalysisReportResponse> => {
    const response = await api.get<CostToSaleAnalysisReportResponse>('/reports/cost-to-sale-analysis', {
        params: {
            startDate: params.startDate,
            endDate: params.endDate,
            qualityId: params.qualityId,
            currency: params.currency,
        }
    });
    return response.data;
};

export const getMergeStockValue = async (
    params: YarnStockValueParams
): Promise<YarnStockValueResponse> => {
    const response = await api.get<YarnStockValueResponse>('/reports/merge-stock-value', {
        params: {
            date: params.date,
        }
    });
    return response.data;
};

export const getBatchStock = async (
    params: BatchStockParams
): Promise<BatchStockResponse> => {
    const response = await api.get<BatchStockResponse>('/reports/batch-roll-stock', {
        params: {
            date: params.date,
            qualityId: params.qualityId,
            batchState: params.batchState,
        }
    });
    return response.data;
};